const NormalLayout = ({ children }) => {
    return (


<>

<nav className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white" id="sidenavAccordion">
<a className="navbar-brand" href="index.html">AGBAR PunchOut</a>
</nav>


<br /><br />
<div id="layoutSidenav_content">
    <main>
    {children}
    </main>
    <footer className="footer mt-auto footer-light">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 small"></div>
                <div className="col-md-6 text-md-right small">
                    Copyright &copy; EconocomPS 2025
                </div>
            </div>
        </div>
    </footer>
</div>


</>)
    
  };
  export default NormalLayout;